import React, { useContext, useEffect, useState } from "react";

import {
  Box,
  Grid,
  Typography,
  CssBaseline,
  Avatar,
  Card,
  CardContent,
  CardActions,
  Button,
  IconButton,
} from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";

import { Fragment } from "react";
import SidebarNavigation from "../components/layout/sidebar-navigation";
import UserIcon from "../components/icons/userIcon";

import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
// import TopBarNavigation from "../components/layout/top-bar";

// import productCategory from "../data/product-category.json";
import globalConfig from "../config/globalConfig.json";
import AuthContext from "../store/auth/auth-context";
import useHttp from "../hooks/use-http";

import Dialog from "@mui/material/Dialog";
import { useTheme } from "@mui/material/styles";
// import useMediaQuery from "@mui/material/useMediaQuery";
import { NavLink } from "react-router-dom";
import SupportForm from "../components/layout/support-form";
// import { textAlign } from "@mui/system";
// import { WidthFull } from "@mui/icons-material";
// import { bgcolor } from "@mui/system";

const Home = () => {
  const authCxt = useContext(AuthContext);
  const [open, setOpen] = useState(false);
  const [downloadType, setDownloadType] = useState("");
  const [downloadProduct, setDownloadProduct] = useState("");
  const [downloadProductCategory, setDownloadProductCategory] = useState("");
 

  const [value, setValue] = React.useState("all");
  const {
    isLoading,
    isError,
    message,
    sendRequest: getProductLists,
  } = useHttp();
  const {
    isLoading: isProductCategoryLoading,
    isError: isProductCategoryError,
    message: productCategoryMessage,
    sendRequest: getProductCategories,
  } = useHttp();
  const [productListState, setProductListState] = useState<any>([]);

  const getProductListsResponse = (res: any) => {
    if (res.data) {
      setProductListState(res.data);
    }
  };

  const getProductCategoriesResponse = (res: any) => {
    if (res.data) {
      setProductCategory(res.data);
      // console.log()
    }
  };
  const [productCategory, setProductCategory] = useState<any>([]);
  

  useEffect(() => {
    getProductLists(
      {
        URL: "/api/product",
        method: "GET",
        header: {
          "Content-Type": "application/json",
        },
      },
      getProductListsResponse
    );

    getProductCategories(
      {
        URL: "/api/product/categories",
        method: "GET",
        header: {
          "Content-Type": "application/json",
        },
      },
      getProductCategoriesResponse
    );



  }, []);

  // useEffect(() => {
  //   if (productListState.length > 0)
  //     setValue(productListState[0].ReferenceName);
  // }, [productListState]);

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };

  const {
    isLoading: isDownloadLoading,
    isError: isDownloadError,
    message: downloadMessage,
    sendRequest: DownloadExtensions,
  } = useHttp();

  const downloadExtensionsHandler = () => {
    window.open(
      `${globalConfig.SERVER_HOST}/api/download?type=${downloadType}&product=${downloadProduct}&category=${downloadProductCategory}`
    );
    setOpen(false);
  };

  const theme = useTheme();
  // const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  const handleClickOpen = (data: any) => {

    setDownloadType(data.type);
    setDownloadProduct(data.product || value);
    setDownloadProductCategory(data.category || "");
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const [formOpenState, setFormOpenState] = useState(false);
  const contactHandler = (data: any) => {
    // console.log("click Contact")
    setFormOpenState(true);
  };

  return (
    <Fragment>
      <SupportForm
        supportFor={"contactUs"}
        openState={formOpenState}
        setFormOpenState={setFormOpenState}
      />

      <Dialog open={open} onClose={handleClose}>
        <Grid
          display={"flex"}
          width={"100%"}
          alignItems={"center"}
          justifyContent={"center"}
          pt={3}
        >
          <Grid item>
            <Typography
              variant="h6"
              sx={{ fontSize: "17px", fontWeight: "400" }}
            >
              {"Download options for App Extensions"}
            </Typography>
          </Grid>
        </Grid>

        <Grid
          display={"flex"}
          width={"100%"}
          alignItems={"center"}
          justifyContent={"center"}
          pt={1}
        >
          <Grid item>
            <Typography variant="body1" sx={{ fontSize: "12px" }}>
              {/* {"Select your preference"} */}
            </Typography>
          </Grid>
        </Grid>
        <Grid
          display={"flex"}
          width={"100%"}
          alignItems={"center"}
          justifyContent={"center"}
          p={3}
        >
          <Grid item>
            <LoadingButton
              onClick={downloadExtensionsHandler}
              disabled={!authCxt.userInfo?.isVarified}
              loading={isDownloadLoading}
              variant="contained"
              sx={{
                width: "140px",
                // bgcolor: "#ff8d24",
                fontSize: "11px",
                bgcolor: "#3A3A3A",
                "&:hover": {
                  bgcolor: "#3a3a3ae3",
                },
              }}
            >
              Without samples
            </LoadingButton>
            <LoadingButton
              onClick={downloadExtensionsHandler}
              // disabled={!authCxt.userInfo?.isVarified}
              disabled={true}
              loading={isDownloadLoading}
              variant="outlined"
              sx={{
                ml: 3,
                width: "140px",
                fontSize: "11px",
                border: "1px solid #3A3A3A",
                color: "#3A3A3A",
                "&:hover": {
                  border: "1px solid #3A3A3A",
                },
              }}
            >
              with samples
            </LoadingButton>
          </Grid>
        </Grid>
      </Dialog>

      <Box ml={2} mt={8} sx={{ width: "100%" }}>
        <TabContext value={value} >
          <Grid flexDirection={"column"} display={"flex"}>
            <Box sx={{ borderBottom: 1, borderColor: "divider", mr: "16px" }}>
              
                <TabList
                onChange={handleChange}
                aria-label="lab API tabs example"
                // sx={{display: "none"}}
                >
                <Tab key="all" label="All" value="all" />
                {productListState.map((product: any, index: number) => (
                  <Tab
                  key={index}
                  label={product.Name}
                  value={product.ReferenceName}
                  />
                ))}
                </TabList>
            </Box>
            <Box className="tab-inner-scroll">
              {/* {productListState.map((product: any, index: number) => ( */}
                <TabPanel key="all" value="all">
                  <Grid container display={"flex"} flexDirection={"column"}>
                    <Grid container display={"flex"} flexDirection={"row"} spacing={3}>
                      {productCategory.map((productCategory: any, index: number) => (
                      <Grid item key={index}>
                        <Card sx={{ width: 220, height: 223 }}>
                        <CardContent sx={{ textAlign: "center", pb: "5px" }}>
                          <Grid
                          display={"flex"}
                          flexDirection={"column"}
                          justifyContent={"center"}
                          alignItems={"center"}
                          >
                          <Grid
                            container
                            display={"flex"}
                            justifyContent={"space-between"}
                          >
                            <Grid item xs={2}>
                            {""}
                            </Grid>
                            <Grid item xs={8} alignContent={"center"}>
                            <Box
                              display={"flex"}
                              justifyContent={"center"}
                              sx={{
                              width: "100%",
                              height: "60px",
                              mt: 1,
                              }}
                            >
                              <Avatar
                              sx={{
                                width: "60px",
                                height: "58px",
                              }}
                              src={
                                "/assets/Product Icons/" +
                                productCategory.Icon +
                                ".svg"
                              }
                              />
                            </Box>
                            </Grid>
                            <Grid
                            item
                            xs={2}
                            display={"flex"}
                            justifyContent={"center"}
                            >
                            {productCategory.IsBeta == true ? (
                              <Button
                              aria-label="Beta Version"
                              sx={{
                                color: "#F47907",
                                cursor: "default",
                                bgcolor: "#FFF2CD",
                                height: "15px",
                                minWidth: "38px",
                                fontSize: "9px",
                                fontWeight: "400",
                                borderRadius: "10px",
                                ":hover": {
                                bgcolor: "#FFF2CD",
                                },
                              }}
                              >
                              Beta
                              </Button>
                            ) : (
                              ""
                            )}
                            </Grid>
                          </Grid>

                          <Box>
                            <Typography
                            variant="subtitle1"
                            component="div"
                            pt={1}
                            sx={{ fontSize: "18px" }}
                            >
                            {productCategory.Name}
                            </Typography>
                          </Box>
                          <Box mt={1}>
                            <Typography
                            variant="body2"
                            className="card_description"
                            color="text.secondary"
                            sx={{
                              fontSize: "14px",
                              width: "180px",
                              height: "40px",
                              overflow: "hidden",
                            }}
                            >
                            {productCategory.Description}
                            </Typography>
                          </Box>
                          </Grid>
                        </CardContent>
                        <CardActions>
                          <Box
                          sx={{ width: "100%", fontSize: "12px" }}
                          pl={1}
                          >
                          <Grid
                            display={"flex"}
                            flexDirection={"row"}
                            justifyContent={"space-between"}
                            alignItems={"center"}
                          >
                            <Box>
                            <NavLink
                              to={
                              productCategory.IsAvailable
                              ? `/products/${productListState.find((product: any) => product.ID === productCategory.ProductID)?.ReferenceName}/${productCategory.ReferenceName}`
                              : ""
                              }
                            >
                              <Button
                              disabled={
                              !(
                              authCxt.userInfo?.isVarified &&
                              productCategory.IsAvailable
                              )
                              }
                              sx={{
                              "&.Mui-disabled": {
                              bgcolor: "#fff",
                              },
                              }}
                              >
                              <Typography
                              variant="body2"
                              color="text.secondary"
                              sx={{ color: "#F47907" }}
                              >
                              know more
                              </Typography>
                              </Button>
                            </NavLink>
                            </Box>
                            <Box>
                            {!productCategory.IsAutoSetup ? (
                              <Button
                              disabled={!productCategory.IsAvailable}
                              aria-label="Download Extension"
                              onClick={() =>
                                contactHandler({
                                supportFor:
                                  productCategory.ReferenceName,
                                })
                              }
                              sx={{
                                border: !productCategory.IsAvailable
                                ? "0px solid #3A3A3A"
                                : "1px solid #3A3A3A",
                                color: "#3A3A3A",
                                height: "22px",
                                borderRadius: "5px",
                                ":hover": {
                                bgcolor: "#F9F9F9",
                                },
                              }}
                              >
                              Contact us
                              </Button>
                            ) : (
                              <Box>
                              <NavLink to={"/account/"}>
                                <IconButton
                                disabled={
                                  !(
                                  authCxt.userInfo?.isVarified &&
                                  productCategory.IsAvailable
                                  )
                                }
                                sx={{
                                  border: "1px solid #3A3A3A",
                                  width: "22px",
                                  height: "22px",
                                  borderRadius: "5px",
                                  mr: "10px",
                                  "&.Mui-disabled": {
                                  background: "#F9F9F9",
                                  border: "1px solid #C1C1C1",
                                  },
                                }}
                                aria-label="Manage Users"
                                >
                                <Avatar
                                  sx={{
                                  width: "15px",
                                  height: "15px",
                                  color: "#C1C1C1",
                                  }}
                                  src={"/assets/icons/users.svg"}
                                />
                                </IconButton>
                              </NavLink>
                              <IconButton
                                onClick={() => {
                                handleClickOpen({
                                  type: "category",
                                  product: productListState.find((product: any) => product.ID === productCategory.ProductID)?.ReferenceName,
                                  category: productCategory.ReferenceName,
                                });
                                }}
                                disabled={
                                !(
                                  authCxt.userInfo?.isVarified &&
                                  productCategory.IsAvailable
                                )
                                }
                                aria-label="Download Extension"
                                sx={{
                                bgcolor: "#3A3A3A",
                                width: "22px",
                                height: "22px",
                                borderRadius: "5px",
                                "&:hover": {
                                  bgcolor: "#3a3a3ae3",
                                },
                                }}
                              >
                                <Avatar
                                sx={{
                                  width: "15px",
                                  height: "15px",
                                }}
                                src={"/assets/icons/Download.svg"}
                                />
                              </IconButton>
                              </Box>
                            )}
                            </Box>
                          </Grid>
                          </Box>
                        </CardActions>
                        </Card>
                      </Grid>
                      ))}
                    </Grid>
                  </Grid>
                </TabPanel>
                {productListState.map((product: any, index: number) => (
                  <TabPanel key={index} value={product.ReferenceName}>
                    <Grid container display={"flex"} flexDirection={"column"}>
                      <Grid display={"flex"} justifyContent={"space-between"} mb={0}>
                        <Box>
                          <Typography
                            color={"#0B0800"}
                            variant="h6"
                            sx={{ fontSize: "20px", fontWeight: 400 }}
                          >
                            {product.Name}
                          </Typography>
                        </Box>
                        <Box>
                          {product.ReferenceName != "code_management" ? (
                            <Button
                              onClick={() => {
                                handleClickOpen({ type: "group" });
                              }}
                              variant="contained"
                              sx={{
                                width: "110px",
                                bgcolor: "#3A3A3A",
                                "&:hover": {
                                  bgcolor: "#3a3a3ae3",
                                },
                              }}
                              disabled={!authCxt.userInfo?.isVarified}
                            >
                              Download all
                            </Button>
                          ) : (
                            ""
                          )}
                        </Box>
                      </Grid>
                      <Grid mb={3}>
                        <Typography
                          variant="body2"
                          sx={{ fontSize: "14px" }}
                          color={"#8D8D8D"}
                        >
                          {product.Description}
                        </Typography>
                      </Grid>

                      <Grid
                        container
                        display={"flex"}
                        flexDirection={"row"}
                        spacing={3}
                      >
                        {productCategory
                          .filter((item: { ProductID: number }) => item.ProductID == product.ID)
                          .map((productCategory: any, index: number) => (
                            <Grid item key={index}>
                              <Card sx={{ width: 220, height: 223 }}>
                                <CardContent
                                  sx={{ textAlign: "center", pb: "5px" }}
                                >
                                  <Grid
                                    display={"flex"}
                                    flexDirection={"column"}
                                    justifyContent={"center"}
                                    alignItems={"center"}
                                  >
                                    <Grid
                                      container
                                      display={"flex"}
                                      justifyContent={"space-between"}
                                    >
                                      <Grid item xs={2}>
                                        {""}
                                      </Grid>
                                      <Grid
                                        item
                                        xs={8}
                                        alignContent={"center"}
                                      >
                                        <Box
                                          display={"flex"}
                                          justifyContent={"center"}
                                          sx={{
                                            width: "100%",
                                            height: "60px",
                                            mt: 1,
                                          }}
                                        >
                                          <Avatar
                                            sx={{
                                              width: "60px",
                                              height: "58px",
                                            }}
                                            src={
                                              "/assets/Product Icons/" +
                                              productCategory.Icon +
                                              ".svg"
                                            }
                                          />
                                        </Box>
                                      </Grid>
                                      <Grid item xs={2} display={"flex"}
                                          justifyContent={"center"}>
                                        {productCategory.IsBeta==true ?
                                        <Button
                                          aria-label="Beta Version"
                                          sx={{
                                            color: "#F47907",
                                            cursor: "default",
                                            bgcolor: "#FFF2CD",
                                            height: "15px",
                                            minWidth: "38px",
                                            fontSize: "9px",
                                            fontWeight: "400",
                                            borderRadius: "10px",
                                            ":hover": {
                                              bgcolor: "#FFF2CD",
                                            },
                                          }}
                                        >
                                          Beta
                                        </Button>
                                        : ""}
                                      </Grid>
                                    </Grid>

                                    <Box>
                                      <Typography
                                        variant="subtitle1"
                                        component="div"
                                        pt={1}
                                        sx={{ fontSize: "18px" }}
                                      >
                                        {productCategory.Name}
                                      </Typography>
                                    </Box>
                                    <Box mt={1}>
                                      <Typography
                                        variant="body2"
                                        className="card_description"
                                        color="text.secondary"
                                        sx={{
                                          fontSize: "14px",
                                          width: "180px",
                                          height: "40px",
                                          overflow: "hidden",
                                        }}
                                      >
                                        {productCategory.Description}
                                      </Typography>
                                    </Box>
                                  </Grid>
                                </CardContent>
                                <CardActions>
                                  <Box
                                    sx={{ width: "100%", fontSize: "12px" }}
                                    pl={1}
                                  >
                                    <Grid
                                      display={"flex"}
                                      flexDirection={"row"}
                                      justifyContent={"space-between"}
                                      alignItems={"center"}
                                    >
                                      <Box>
                                        <NavLink
                                          to={
                                            productCategory.IsAvailable
                                              ? `/products/${product.ReferenceName}/${productCategory.ReferenceName}`
                                              : ""
                                          }
                                        >
                                          <Button
                                            disabled={
                                              !(
                                                authCxt.userInfo?.isVarified &&
                                                productCategory.IsAvailable
                                              )
                                            }
                                            sx={{
                                              "&.Mui-disabled": {
                                                bgcolor: "#fff",
                                              },
                                            }}
                                          >
                                            <Typography
                                              variant="body2"
                                              color="text.secondary"
                                              sx={{color:"#F47907"}}
                                            >
                                              know more
                                            </Typography>
                                          </Button>
                                        </NavLink>
                                      </Box>
                                      <Box>
                                        {!productCategory.IsAutoSetup ? (
                                          <Button
                                            disabled={
                                              !productCategory.IsAvailable
                                            }
                                            aria-label="Download Extension"
                                            onClick={() =>
                                              contactHandler({
                                                supportFor:
                                                  productCategory.ReferenceName,
                                              })
                                            }
                                            sx={{
                                              border: !productCategory.IsAvailable
                                                ? "0px solid #3A3A3A"
                                                : "1px solid #3A3A3A",
                                              color: "#3A3A3A",
                                              height: "22px",
                                              borderRadius: "5px",
                                              ":hover": {
                                                bgcolor: "#F9F9F9",
                                              },
                                            }}
                                          >
                                            Contact us
                                          </Button>
                                        ) : (
                                          <Box>
                                            <NavLink to={"/account/"}>
                                              <IconButton
                                                disabled={
                                                  !(
                                                    authCxt.userInfo
                                                      ?.isVarified &&
                                                    productCategory.IsAvailable
                                                  )
                                                }
                                                sx={{
                                                  border: "1px solid #3A3A3A",
                                                  width: "22px",
                                                  height: "22px",
                                                  borderRadius: "5px",
                                                  mr: "10px",
                                                  "&.Mui-disabled": {
                                                    background: "#F9F9F9",
                                                    border: "1px solid #C1C1C1",
                                                  },
                                                }}
                                                aria-label="Manage Users"
                                              >
                                                <Avatar
                                                  sx={{
                                                    width: "15px",
                                                    height: "15px",
                                                    color: "#C1C1C1",
                                                  }}
                                                  src={"/assets/icons/users.svg"}
                                                />
                                              </IconButton>
                                            </NavLink>
                                            <IconButton
                                              onClick={() => {
                                                handleClickOpen({
                                                  type: "category",
                                                  category: productCategory.ReferenceName,
                                                });
                                              }}
                                              disabled={
                                                !(
                                                  authCxt.userInfo?.isVarified &&
                                                  productCategory.IsAvailable
                                                )
                                              }
                                              aria-label="Download Extension"
                                              sx={{
                                                bgcolor: "#3A3A3A",
                                                width: "22px",
                                                height: "22px",
                                                borderRadius: "5px",
                                                "&:hover": {
                                                  bgcolor: "#3a3a3ae3",
                                                },
                                              }}
                                            >
                                              <Avatar
                                                sx={{
                                                  width: "15px",
                                                  height: "15px",
                                                }}
                                                src={"/assets/icons/Download.svg"}
                                              />
                                            </IconButton>
                                          </Box>
                                        )}
                                      </Box>
                                    </Grid>
                                  </Box>
                                </CardActions>
                              </Card>
                            </Grid>
                          ))}
                      </Grid>
                    </Grid>
                  </TabPanel>
                ))}
              {/* ))} */}
            </Box>
          </Grid>
        </TabContext>
      </Box>
    </Fragment>
  );
};

export default Home;
